import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const QUARTER = () => {
  return (
    <CardSection id="QUARTER" title="QUARTER">
      <Paragraph>지정된 날짜/시간 객체에서 분기를 정수로 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>QUARTER(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 분기를 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>QUARTER(`Date`)</Paragraph>
        <Img src="computeQuarter" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체 혹은 날짜/시간 객체를
          포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
